<template>
  <div class="page-device" :style="{ height: pageHeight + 'px' }">
    <div class="real-time">
      <div class="option-box">
        <el-select v-model="tower" filterable placeholder="选择楼" @change="towerChange">
          <el-option v-for="item in towers" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="floor" placeholder="选择层" @change="floorChange">
          <el-option v-for="item in floors" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="room" placeholder="选择房" @change="roomChange">
          <el-option v-for="item in rooms" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input style="max-width: 120px; margin-right: 20px;" placeholder="雷达SN" v-model="searchSn"
          @input="searchChange"></el-input>
        <!-- <el-select
          v-model="device"
          placeholder="选择设备"
          @change="deviceChange"
        >
          <el-option
            v-for="item in devices"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-button class="option-btn" @click="reset">重置</el-button>
        <!-- <el-button class="option-btn">筛选</el-button> -->
        <!-- <el-button class="option-btn" @click="batchSet">批量设置</el-button> -->
        <el-upload class="upload" :headers="headers" accept=".bin" action="/plat/sstk-plat/api/device/param/upload-file"
          name="fileUpload" :show-file-list="false" :on-success="uploadFileSuccess" :on-error="uploadFileFail"
          ref="uploadFile" :disabled="isBatch">
          <el-button class="option-btn" slot="trigger" @click="updateRadars">批量升级</el-button>
        </el-upload>
        <!-- <el-button class="option-btn" @click="addDelDevice"
          >添加/删除设备</el-button
        > -->
      </div>
      <div class="monitor-info-title">
        <div>
          <i class="check-box" :class="
            isAllCheck == 0
              ? ''
              : isAllCheck == 1
                ? 'check-half-box'
                : isAllCheck == 2
                  ? 'check-all-box'
                  : ''
          " @click="allCheck"></i>
        </div>
        <div>房间</div>
        <div>安装位置</div>
        <div>设备编号</div>
        <div>设备类型</div>
        <div>参数设置</div>
        <div>其它设置</div>
        <!-- <div>告警设置</div> -->
        <div>信息设置</div>
        <div>雷达升级</div>
        <!-- <div>wifi升级</div> -->
        <div>操作</div>
      </div>
      <el-scrollbar style="height: 100%">
        <div class="list-box">
          <div class="monitor-info" :style="{ background: index % 2 == 0 ? '#efefef' : '' }"
            v-for="(item, index) in showDeviceList" :key="'showDevice' + index">
            <div>
              <i :class="
                item.isSelect ? 'check-box check-box-select' : 'check-box'
              " @click="selectList(item)"></i>
            </div>
            <div>{{ item.roomName }}</div>
            <div>{{ item.bedName }}</div>
            <div>{{ item.sn }}</div>
            <div>{{ item.typeText }}</div>
            <div class="radar-set-text" @click="setRadar(item)">设置</div>
            <!-- <div class="radar-set-text" @click="handleAlarm(item)">设置</div> -->
            <div class="radar-set-text" @click="setOther(item)">设置</div>
            <div class="radar-set-text" @click="handleRadar(item)">设置</div>
            <el-upload class="upload" :headers="headers" accept=".bin"
              action="/plat/sstk-plat/api/device/param/upload-file" name="fileUpload" :show-file-list="false"
              :on-success="uploadFileSuccess" :on-error="uploadFileFail" ref="uploadFile">
              <div>
                <img :src="updateImg" v-if="item.updateRadarState == undefined" @click="updateRadar(item)" />{{
                  item.updateRadarState
                }}
              </div>
            </el-upload>
            <!-- <el-upload
              class="upload"
              :headers="headers"
              action="/plat/sstk-plat/api/device/param/upload-file"
              name="fileUpload"
              :show-file-list="false"
              :on-success="uploadFileSuccess"
              :on-error="uploadFileFail"
              ref="uploadFile"
            >
              <div>
                <img
                  :src="updateImg"
                  v-if="item.updateWifiState == undefined"
                  @click="updateWifi(item)"
                />{{ item.updateWifiState }}
              </div>
            </el-upload> -->
            <div class="radar-set-text" @click="radarInfo(item)" width="350">
              详情
            </div>
          </div>
        </div>
      </el-scrollbar>
      <el-pagination :page-size="pageSize" :page-sizes="[15, 9999]" :total="deviceTotal"
        layout="prev,pager,next,jumper,sizes,->,total" @current-change="pageChange" @size-change="sizeChange">
      </el-pagination>
    </div>

    <div class="mask-box" v-show="isMask" ref="mask">
      <div class="device-add-box" v-if="isAddDelRadar">
        <div class="device-title-box">
          <div class="device-room-name">{{ deviceTitle }}</div>
          <img :src="closeImg" @click="back" />
        </div>

        <div class="device-select-box">
          <el-select v-model="selectRadar" placeholder="选择雷达">
            <el-option v-for="item in radarTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-time-picker
            is-range
            v-model="monitorTime"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
            style="margin-right: 20px"
            :picker-options="{
              selectableRange: ['00:00:00 - 11:59:59']
            }"
          >
          </el-time-picker> -->
          <el-time-picker v-model="startTime" placeholder="开始时间" value-format="HH:mm:ss" style="margin-right: 20px">
          </el-time-picker>
          <el-time-picker v-model="endTime" placeholder="结束时间" value-format="HH:mm:ss" style="margin-right: 20px">
          </el-time-picker>
          <el-select v-model="bed" placeholder="选择位置">
            <el-option v-for="item in beds" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div class="device-select-text">雷达IP</div>
          <el-input v-model="radarIp"></el-input>
          <div class="device-select-text">雷达端口</div>
          <el-input v-model="radarPort"></el-input>
          <div class="device-select-text">雷达SN码</div>
          <el-input v-model="radarSn"></el-input>
          <!-- <div class="device-select-text">SetPort</div>
          <el-input v-model="radarSetPort"></el-input> -->
          <el-button class="device-btn" @click="addRadar">添加</el-button>
          <el-button class="device-btn" @click="removeRadar">删除</el-button>
        </div>

        <div class="device-list-title-box">
          <div class="device-list-title-one"></div>
          <div class="device-list-title-one"></div>
          <div class="device-list-title">雷达名称</div>
          <div class="device-list-title">监控时间段</div>
          <div class="device-list-title">安装位置</div>
          <div class="device-list-title">雷达IP</div>
          <div class="device-list-title">雷达端口</div>
          <div class="device-list-title">雷达SN码</div>
          <!-- <div class="device-list-title">SetPort</div> -->
        </div>
        <!-- <el-scrollbar style="height: 100%"></el-scrollbar> -->
        <div class="device-content-box">
          <div class="device-list-content-box" :style="{ background: index % 2 == 0 ? '#efefef' : '' }"
            v-for="(item, index) in allDevices" :key="'all' + index">
            <div class="device-list-content-one">
              <div :class="item.delSelect ? 'device-check-box-del' : ''" @click="selectDelList(item)"
                class="device-check-box"></div>
            </div>
            <div class="device-list-content-one">
              <img :src="item.radarType == '1001' ? radarLifeImg : radarDownImg" />
            </div>
            <div class="device-list-content">{{ item.name }}</div>
            <div class="device-list-content">
              {{ item.startTime }}~{{ item.endTime }}
            </div>
            <div class="device-list-content">{{ item.bedName }}</div>
            <div class="device-list-content">{{ item.ip }}</div>
            <div class="device-list-content">{{ item.port }}</div>
            <div class="device-list-content">{{ item.sn }}</div>
            <!-- <div class="device-list-content">{{ item.setPort }}</div> -->
          </div>
        </div>
      </div>

      <div class="life-radar-box" v-if="isLifeRadar">
        <div class="life-radar-header">
          <div class="life-radar-title">参数设置</div>
          <img :src="closeImg" class="life-radar-close" @click="back" />
        </div>
        <div class="life-radar-content">
          <div class="life-set-list">
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">床体距离(m)</div>
              <el-input v-model="lifeSets.t.bedRange"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸能量门限</div>
              <el-input v-model="lifeSets.t.zeroPowerThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸置信度门限</div>
              <el-input v-model="lifeSets.t.zeroConfidenceThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">有效单元个数</div>
              <el-input v-model="lifeSets.t.binsValid"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸滤波帧数</div>
              <el-input v-model="lifeSets.t.breathFilterBufferSize"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">心跳滤波帧数</div>
              <el-input v-model="lifeSets.t.heartFilterBufferSize"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">有无人起点</div>
              <el-input v-model="lifeSets.t.rangeStartIndIfEmpty"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">有无人终点</div>
              <el-input v-model="lifeSets.t.rangeEndIndIfEmpty"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">有无人幅度门限</div>
              <el-input v-model="lifeSets.t.threIfEmpty"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">有无人窗长</div>
              <el-input v-model="lifeSets.t.windowLenIfEmpty"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">体动帧数</div>
              <el-input v-model="lifeSets.t.turnBufferSize"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">体动幅度门限</div>
              <el-input v-model="lifeSets.t.turnBufferSumThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">帧率</div>
              <el-input v-model="lifeSets.t.frameSkipNum"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">左侧距离</div>
              <el-input v-model="lifeSets.t.leftRange"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">右侧距离</div>
              <el-input v-model="lifeSets.t.rightRange"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">左侧角度单元</div>
              <el-input v-model="lifeSets.t.leftAngleInd"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">右侧角度单元</div>
              <el-input v-model="lifeSets.t.rightAngleInd"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">起身窗长</div>
              <el-input v-model="lifeSets.t.getUpBufferSize"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">起身阈值</div>
              <el-input v-model="lifeSets.t.getUpThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">检测模式</div>
              <el-input v-model="lifeSets.t.searchType"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">体动检测间隔帧个数</div>
              <el-input v-model="lifeSets.t.keepCountThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">抗干扰高门限</div>
              <el-input v-model="lifeSets.t.emptyToHasThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">抗干扰门限恢复低门限帧计数</div>
              <el-input v-model="lifeSets.t.hasToEmptyCntThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">连续无人帧计数门限</div>
              <el-input v-model="lifeSets.t.continueEmptyThre"></el-input>
            </div>
            <!-- <div class="life-set-box life-set-box-four">
              <div class="life-set-name">告警功能-使能</div>
              <el-input v-model="lifeSets.t.alarmEn"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸心跳报警滑窗长度</div>
              <el-input v-model="lifeSets.t.saveMinNum"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸心跳报警事件阈值</div>
              <el-input v-model="lifeSets.t.alarmMinThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸预警高阈值</div>
              <el-input v-model="lifeSets.t.breathHighAlarmThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">呼吸预警低阈值</div>
              <el-input v-model="lifeSets.t.breathLowAlarmThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">心跳预警高阈值</div>
              <el-input v-model="lifeSets.t.heartHighAlarmThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">心跳预警低阈值</div>
              <el-input v-model="lifeSets.t.heartLowAlarmThre"></el-input>
            </div>
            <div class="life-set-box life-set-box-four">
              <div class="life-set-name">长时间离床阈值</div>
              <el-input v-model="lifeSets.t.leaveBedLongTimeThre"></el-input>
            </div> -->
            <!-- <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i> -->
          </div>
          <div class="life-set-btn-box">
            <el-button class="life-set-btn" @click="lifeRadarSet">应用</el-button>
          </div>
        </div>
      </div>

      <div class="down-radar-box" v-if="isDownRadar">
        <div class="life-radar-header">
          <div class="life-radar-title">参数设置</div>
          <img :src="closeImg" class="life-radar-close" @click="back" />
        </div>
        <div class="life-radar-content">
          <div class="life-set-list">
            <div class="life-set-box">
              <div class="life-set-name">报警延长时间(s)</div>
              <el-input v-model="downSets.second" placeholder="请输入报警延长时间"></el-input>
            </div>
            <el-button class="life-set-btn" style="margin: 0 auto 20px" @click="downRadarSetDelay">应用</el-button>
            <div class="life-set-box">
              <div class="life-set-name">左边界(m)</div>
              <el-input v-model="downSets.boundaryLeft" placeholder="请输入左边界"></el-input>
            </div>
            <div class="life-set-box">
              <div class="life-set-name">右边界(m)</div>
              <el-input v-model="downSets.boundaryRight" placeholder="请输入右边界"></el-input>
            </div>
            <div class="life-set-box">
              <div class="life-set-name">前方边界(m)</div>
              <el-input v-model="downSets.boundaryForward" placeholder="请输入前方边界"></el-input>
            </div>
            <div class="life-set-box">
              <div class="life-set-name">后边界(m)</div>
              <el-input v-model="downSets.boundaryBackward" placeholder="请输入后边界"></el-input>
            </div>
          </div>
          <div class="life-set-btn-box">
            <el-button class="life-set-btn" @click="downRadarSet">应用</el-button>
          </div>
        </div>
      </div>

      <div class="down-radar-box" v-if="isOtherSet">
        <div class="life-radar-header">
          <div class="life-radar-title">其它设置</div>
          <img :src="closeImg" class="life-radar-close" @click="back" />
        </div>
        <div class="life-radar-content">
          <div class="life-set-list">
            <div class="life-set-box">
              <div class="life-set-name">微动检测值</div>
              <!-- <el-input v-model="mircoMoveThre" placeholder="请输入微动检测值"></el-input> -->
              <el-select v-model="mircoMoveThre" placeholder="选择档位">
                <el-option v-for="item in mircoMoveThreList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button class="life-set-btn" style="margin: 0 auto 20px" @click="handleSetMirco">应用</el-button>
            <div class="life-set-box">

            </div>
            <div class="life-set-box">
              <div style="margin-bottom: 10px; display: flex; justify-content: space-between;">
                <span class="life-set-name">滞留开关</span>
                <el-switch v-model="retentionEnable" :active-value="1" :inactive-value="2"></el-switch>
              </div>
              <div class="life-set-name">滞留时间(分)</div>
              <el-input v-model="retentionMinute" placeholder="请输入滞留时间"></el-input>
            </div>
            <el-button class="life-set-btn" style="margin: 0 auto 20px" @click="handleSetRention">应用</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-drawer title="雷达设置" :visible.sync="drawer" direction="rtl" size="20%" :append-to-body="true">
      <div class="drawer">
        <div class="drawer-content">
          <el-form :model="radarForm">
            <el-form-item label="名称" label-width="80px">
              <el-input v-model="radarForm.name" />
            </el-form-item>
            <!-- <el-form-item label="睡眠监测开始时间" label-width="150px">
              <el-time-picker
                v-model="radarForm.startTime"
                placeholder="睡眠监测开始时间"
                value-format="HH:mm:ss"
              >
              </el-time-picker>
            </el-form-item> -->

            <!-- <el-form-item label="睡眠监测结束时间" label-width="150px">
              <el-time-picker
                v-model="radarForm.endTime"
                placeholder="睡眠监测结束时间"
                value-format="HH:mm:ss"
              >
              </el-time-picker>
            </el-form-item> -->

            <el-form-item label="wifi版本" label-width="80px">
              <el-input v-model="radarForm.wifiVersion" disabled />
            </el-form-item>

            <el-form-item label="雷达版本" label-width="80px">
              <el-input v-model="radarForm.softVersion" disabled />
            </el-form-item>

            <el-form-item label="ccid" label-width="80px">
              <el-input v-model="radarForm.ccid" disabled />
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer">
          <el-button @click="drawer = false">取消</el-button>
          <el-button type="primary" @click="updateRadarInfo">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="雷达信息设置" :visible.sync="isInfo" direction="rtl" size="20%" :append-to-body="true">
      <div class="drawer">
        <div class="drawer-content">
          <el-form :model="infoForm">
            <el-form-item label="雷达Mac地址" label-width="120px">
              <el-input v-model="infoForm.t.radarMacAddr" />
            </el-form-item>
            <el-form-item label="服务器ip" label-width="120px">
              <el-input v-model="infoForm.t.reportServerIp" />
            </el-form-item>
            <el-form-item label="服务器端口" label-width="120px">
              <el-input v-model="infoForm.t.reportServerPort" />
            </el-form-item>
            <el-form-item label="路由器ssid" label-width="120px">
              <el-input v-model="infoForm.t.radarStaSsid" />
            </el-form-item>
            <el-form-item label="路由器密码" label-width="120px">
              <el-input v-model="infoForm.t.radarStaPwd" />
            </el-form-item>
            <el-form-item label="热点ssid" label-width="120px">
              <el-input v-model="infoForm.t.radarApSsid" />
            </el-form-item>
            <el-form-item label="热点密码" label-width="120px">
              <el-input v-model="infoForm.t.radarApPwd" />
            </el-form-item>
            <el-form-item label="雷达备注信息" label-width="120px">
              <el-input v-model="infoForm.t.radarComment" />
            </el-form-item>
            <el-form-item label="局域网iP" label-width="120px">
              <el-input v-model="infoForm.t.radarStaIp" />
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer">
          <el-button @click="isInfo = false">取消</el-button>
          <el-button type="primary" @click="handleSetRadar">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <div class="alarm-mask-box" v-if="isAlarmMask">
      <div class="alarm-mask">
        <div class="alarm-title-box">
          <div class="alarm-text">告警设置</div>
          <img :src="closeImg" @click="isAlarmMask = false" />
        </div>
        <div class="alarm-content-box">
          <div class="alarm-content-title">
            心跳告警
            <el-switch v-model="alarmForm.heartOpen" :active-value="1" :inactive-value="0"></el-switch>
          </div>
          <div class="alarm-content">
            <div class="alarm-content-info">
              心跳过高阈值
              <el-input v-model="alarmForm.heartHighAlarmThre" style="width: 180px; margin: 0 10px"></el-input>
              <el-time-picker v-model="alarmForm.startHeartHighTime" placeholder="开始时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
              <el-time-picker v-model="alarmForm.endHeartHighTime" placeholder="结束时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
            </div>
            <div class="alarm-content-info">
              心跳过低阈值
              <el-input v-model="alarmForm.heartLowAlarmThre" style="width: 180px; margin: 0 10px"></el-input>
              <el-time-picker v-model="alarmForm.startHeartLowTime" placeholder="开始时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
              <el-time-picker v-model="alarmForm.endHeartLowTime" placeholder="结束时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
            </div>
          </div>
          <div class="alarm-content-title">
            呼吸告警
            <el-switch v-model="alarmForm.breatheOpen" :active-value="1" :inactive-value="0"></el-switch>
          </div>
          <div class="alarm-content">
            <div class="alarm-content-info">
              呼吸过高阈值
              <el-input v-model="alarmForm.breathHighAlarmThre" style="width: 180px; margin: 0 10px"></el-input>
              <el-time-picker v-model="alarmForm.startBreathHighTime" placeholder="开始时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
              <el-time-picker v-model="alarmForm.endBreathHighTime" placeholder="结束时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
            </div>
            <div class="alarm-content-info">
              呼吸过低阈值
              <el-input v-model="alarmForm.breathLowAlarmThre" style="width: 180px; margin: 0 10px"></el-input>
              <el-time-picker v-model="alarmForm.startBreathLowTime" placeholder="开始时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
              <el-time-picker v-model="alarmForm.endBreathLowTime" placeholder="结束时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
            </div>
          </div>
          <div class="alarm-content-title">
            长时间离床
            <el-switch v-model="alarmForm.leaveBedLongTimeOpen" :active-value="1" :inactive-value="0"></el-switch>
          </div>
          <div class="alarm-content">
            <div class="alarm-content-info">
              长时间离床阈值
              <el-input v-model="alarmForm.leaveBedLongTimeThre" style="width: 180px; margin: 0 10px"></el-input>
              <el-time-picker v-model="alarmForm.startLeaveTime" placeholder="开始时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
              <el-time-picker v-model="alarmForm.endLeaveTime" placeholder="结束时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
            </div>
          </div>
          <div class="alarm-content-title">
            长时间未体动
            <el-switch v-model="alarmForm.movingOpen" :active-value="1" :inactive-value="0"></el-switch>
          </div>
          <div class="alarm-content">
            <div class="alarm-content-info">
              长时间未体动阈值
              <el-input v-model="alarmForm.noTurnLongTimeThre" style="width: 180px; margin: 0 10px"></el-input>
              <el-time-picker v-model="alarmForm.startMovingTime" placeholder="开始时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
              <el-time-picker v-model="alarmForm.endMovingTime" placeholder="结束时间" value-format="HH:mm:ss"
                style="margin-right: 20px">
              </el-time-picker>
            </div>
          </div>
          <div class="alarm-content" style="padding: 0">
            <div class="alarm-content-info">
              离床上床
              <el-switch v-model="alarmForm.leaveOrBackBedOpen" :active-value="1" :inactive-value="0"
                style="margin: 0 10px"></el-switch>
              起身告警
              <el-switch v-model="alarmForm.getUpOpen" :active-value="1" :inactive-value="0"
                style="margin: 0 10px"></el-switch>
              呼吸心跳报警滑窗长度
              <el-input v-model="alarmForm.saveMinNum" style="width: 180px; margin: 0 10px"></el-input>
              呼吸心跳报警事件阈值
              <el-input v-model="alarmForm.alarmMinThre" style="width: 180px; margin: 0 10px"></el-input>
            </div>
          </div>
        </div>
        <div class="alarm-btn">
          <el-button class="life-set-btn" type="primary" :disabled="
            alarmForm.saveMinNum == '' ||
            alarmForm.alarmMinThre == '' ||
            alarmForm.noTurnLongTimeThre == '' ||
            alarmForm.startMovingTime == null ||
            alarmForm.endMovingTime == null ||
            alarmForm.leaveBedLongTimeThre == '' ||
            alarmForm.startLeaveTime == null ||
            alarmForm.endLeaveTime == null ||
            alarmForm.breathLowAlarmThre == '' ||
            alarmForm.startBreathLowTime == null ||
            alarmForm.endBreathLowTime == null ||
            alarmForm.breathHighAlarmThre == '' ||
            alarmForm.startBreathHighTime == null ||
            alarmForm.endBreathHighTime == null ||
            alarmForm.heartLowAlarmThre == '' ||
            alarmForm.startHeartLowTime == null ||
            alarmForm.endHeartLowTime == null ||
            alarmForm.heartHighAlarmThre == '' ||
            alarmForm.startHeartHighTime == null ||
            alarmForm.endHeartHighTime == null
          " @click="handleSetAlarm">应用</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBuilding,
  getFloor,
  getRoom,
  getBed,
  getDevice,
  queryRadarType,
  addDevice,
  delDevice,
  updateOAT,
  queryOATProgress,
  queryDelayInfo,
  setDelayInfo,
  queryBoundaryInfo,
  setBoundaryInfo,
  queryArithmetic,
  updateArithmetic,
  updateDevice,
  queryWifiVersion,
  querySoftVersion,
  queryAlarm,
  setAlarm,
  queryRadarInfo,
  setRadarInfo,
  getRetention,
  setRetention,
  getMirco,
  setMirco,
  getCCID
} from "../../api/device";
export default {
  name: "RealTime",
  data() {
    return {
      pageHeight: 0,
      tower: "",
      floor: "",
      room: "",
      bed: "",
      device: "",
      towers: [],
      floors: [],
      rooms: [],
      devices: [],
      allDevices: [],
      showDeviceList: [],
      beds: [],
      allBeds: [],
      radarTypes: [],
      isBatch: true,

      updateImg: require("../../assets/images/system/deviceUpdate.svg"),
      isMask: false,
      monitorTime: "",
      radarIp: "",
      radarLifeImg: require("../../assets/images/system/radarLife.svg"),
      radarDownImg: require("../../assets/images/system/radarDown.svg"),
      closeImg: require("../../assets/images/system/close.svg"),

      deviceTitle: "",
      selectRadar: "",
      radarTypeList: [],
      radarIp: "",
      radarPort: "",
      radarSn: "",
      radarSetPort: "",

      updateRadarList: [],
      updateType: "",

      checkedList: [],

      isAddDelRadar: false,
      isLifeRadar: false,
      isDownRadar: false,
      isOtherSet: true,
      mircoMoveThre: '',
      retentionEnable: 2,
      retentionMinute: '',
      otherInfo: {},

      lifeSets: {
        ipPort: "",
        t: {
          bedRange: "",
          zeroPowerThre: "",
          zeroConfidenceThre: "",
          binsValid: "",
          breathFilterBufferSize: "",
          heartFilterBufferSize: "",
          rangeStartIndIfEmpty: "",
          rangeEndIndIfEmpty: "",
          threIfEmpty: "",
          windowLenIfEmpty: "",
          turnBufferSize: "",
          turnBufferSumThre: "",
          frameSkipNum: "",
          leftRange: "",
          rightRange: "",
          leftAngleInd: "",
          rightAngleInd: "",
          getUpBufferSize: "",
          getUpThre: "",
          searchType: "",
          keepCountThre: "",
          emptyToHasThre: "",
          hasToEmptyCntThre: "",
          continueEmptyThre: "",
          alarmEn: "",
          saveMinNum: "",
          alarmMinThre: "",
          breathHighAlarmThre: "",
          breathLowAlarmThre: "",
          heartHighAlarmThre: "",
          heartLowAlarmThre: "",
          leaveBedLongTimeThre: "",
          noTurnLongTimeThre: "",
        },
      },

      downSets: {
        second: "",
        boundaryLeft: "",
        boundaryRight: "",
        boundaryForward: "",
        boundaryBackward: "",
      },

      selectableRange: ["00:00:00 - 9:59:59", "00:00:00 - 23:59:59"],
      startTime: "",
      endTime: "",

      drawer: false,
      radarForm: {},
      headers: {},
      deviceTotal: 0,
      currPage: 1,
      pageSize: 15,
      isAllCheck: 0,
      isSetAlarm: false,
      isAlarmMask: false,
      alarmForm: {},
      currDevice: {},

      isInfo: false,
      infoForm: { t: {} },
      searchSn: "",
      mircoMoveThreList: [{
        label: '1档',
        value: 1
      }, {
        label: '2档',
        value: 2
      }, {
        label: '3档',
        value: 3
      }, {
        label: '4档',
        value: 4
      }, {
        label: '5档',
        value: 5
      }]
    };
  },
  created() {
    // location.reload();
  },
  mounted() {
    this.initPageHeight();

    window.addEventListener("resize", this.initPageHeight, false);

    this.getTowers();
    this.getFloors();
    this.getRooms();
    this.getBeds();
    // this.getAllBeds();

    this.getRadarType();

    let token = localStorage.getItem("healthyToken");
    if (token) {
      this.headers.token = token;
    }

    this.webSocketInit();
  },
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;
    },

    searchChange() {
      this.getDeviceList()
    },

    // 获取雷达类型
    getRadarType() {
      queryRadarType({
        codeType: "radar_type",
      }).then((res) => {
        this.radarTypes = res.data;
        res.data.forEach((item) => {
          item.label = item.codeName;
          item.value = item.code;
        });
        this.radarTypeList = res.data;
      });
    },

    // 获取楼列表
    getTowers() {
      getBuilding({
        page: 1,
        size: 9999,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.towers = list;
      });
    },

    reset() {
      this.currPage = 1;
      this.tower = "";
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.searchSn = ""
      this.getTowers();
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 选择楼
    towerChange(e) {
      this.currPage = 1;
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.device = "";
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 获取层列表
    getFloors() {
      getFloor({
        page: 1,
        size: 9999,
        buildingId: this.tower,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.floors = list;
      });
    },

    // 选择层
    floorChange(e) {
      this.currPage = 1;
      this.room = "";
      this.bed = "";
      this.device = "";
      this.getRooms();
      this.getBeds();
    },

    // 获取房列表
    getRooms() {
      getRoom({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            item.value = item.id;
            item.label = item.name;
            list.push(item);
          });
        }

        this.rooms = list;
      });
    },

    // 选择房
    roomChange(e) {
      this.currPage = 1;
      this.bed = "";
      this.device = "";
      this.getBeds();
    },

    // 获取位置列表
    getBeds() {
      getBed({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
        roomId: this.room,
      }).then((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            item.value = item.id;
            item.label = item.name;
          });
          this.beds = res.data.items;

          this.getAllBeds();
        } else {
          this.beds = [];
          this.getAllBeds();
          // this.devices = [];
          // this.showDeviceList = []
        }
      });
    },

    // 获取所有位置
    getAllBeds() {
      getBed({
        page: 1,
        size: 9999,
      }).then((res) => {
        this.allBeds = res.data.items;

        this.getDeviceList();
      });
    },

    // 获取设备列表
    getDeviceList() {
      let obj = {
        page: this.currPage,
        size: this.pageSize,
        radarType: "1002", //  跌倒雷达
        id: this.$store.getters.user.id,
        sn: this.searchSn
      };
      if (this.tower) {
        obj.buildingId = this.tower;
      }
      if (this.floor) {
        obj.floorId = this.floor;
      }
      if (this.room) {
        obj.roomId = this.room;
      }
      this.isAllCheck = 0;
      getDevice(obj).then((res) => {
        this.deviceTotal = res.data.total;
        if (res.data.records.length > 0) {
          res.data.records.forEach((item) => {
            item.label = item.name;
            item.value = item.id;
            item.isSelect = false;
            item.delSelect = false;
            if (item.radarType == "1001") {
              item.typeText = "生命体征检测雷达";
            } else if (item.radarType == "1002") {
              item.typeText = "跌倒检测雷达";
            }
          });
          this.allDevices = res.data.records;

          this.allDevices.forEach((item) => {
            this.allBeds.forEach((itm) => {
              if (item.bedId == itm.id) {
                item.roomName = itm.roomName;
                item.roomId = itm.roomId;
                item.bedName = itm.name;
              }
            });
          });

          let list = [];
          list = this.allDevices;
          // this.allDevices.forEach((item) => {
          //   this.beds.forEach((itm) => {
          //     if (item.bedId == itm.id) {
          //       list.push(item);
          //     }
          //   });
          // });

          this.devices = JSON.parse(JSON.stringify(list));
          this.showDeviceList = JSON.parse(JSON.stringify(list));
        } else {
          this.devices = [];
          this.showDeviceList = [];
        }
      });
    },

    // 选择页码
    pageChange(e) {
      this.currPage = e;
      this.getDeviceList();
    },

    sizeChange(e) {
      this.pageSize = e;
      this.getDeviceList();
    },

    // 选择设备列表
    deviceChange() {
      let list = [];
      this.showDeviceList.forEach((item) => {
        if (item.id == this.device) {
          list.push(item);
        }
      });
      this.showDeviceList = list;
    },

    // 选择列表
    selectList(data) {
      // 判断选中状态
      // 未选中————>选中
      if (!data.isSelect) {
        // 判断选中列表是否为空
        if (this.checkedList.length > 0) {
          // 选中列表不为空，判断雷达类型
          // 雷达类型一致，改变选中状态
          if (data.radarType == this.checkedList[0].radarType) {
            data.isSelect = true;
          } else {
            // 雷达类型不一致，提示
            this.$message("所选雷达类型不同");
          }
        } else {
          // 选中列表为空，直接改变状态
          data.isSelect = true;
        }
      } else {
        // 选中————>未选中
        data.isSelect = false;
      }

      this.showDeviceList = JSON.parse(JSON.stringify(this.showDeviceList));

      // 遍历列表，更新选中列表
      let list = [];
      let sList = [];
      this.showDeviceList.forEach((item) => {
        sList.push(item.isSelect);
        if (item.isSelect) {
          list.push(item);
        }
      });

      this.checkedList = list;

      if (sList.indexOf(true) == -1) {
        this.isAllCheck = 0;
      } else if (sList.indexOf(false) == -1) {
        this.isAllCheck = 2;
      } else {
        this.isAllCheck = 1;
      }
    },

    // 全选
    allCheck() {
      if (this.showDeviceList.length > 0) {
        let isExist = false;
        this.showDeviceList.forEach((item) => {
          if (!item.isSelect) {
            isExist = true;
          }
        });

        this.showDeviceList.forEach((item) => {
          if (isExist) {
            item.isSelect = true;
            this.isAllCheck = 2;
          } else {
            item.isSelect = false;
            this.isAllCheck = 0;
          }
        });

        let list = [];
        this.showDeviceList.forEach((item) => {
          if (item.isSelect) {
            list.push(item);
          }
        });

        this.checkedList = list;
      }
    },

    selectDelList(data) {
      data.delSelect = !data.delSelect;

      this.allDevices = JSON.parse(JSON.stringify(this.allDevices));
    },

    // 添加雷达
    addRadar() {
      let name = "";
      this.radarTypeList.forEach((item) => {
        if (item.code == this.selectRadar) {
          name = item.codeName;
        }
      });
      addDevice({
        ip: this.radarIp,
        port: this.radarPort,
        setPort: this.radarSetPort,
        sn: this.radarSn,
        name: name,
        bedId: this.bed,
        radarType: this.selectRadar,
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.getDeviceList();
      });
    },

    // 删除雷达
    removeRadar() {
      let list = [];
      if (this.allDevices.length > 0) {
        this.allDevices.forEach((item) => {
          if (item.delSelect) {
            list.push(item.id);
          }
        });
      }
      delDevice({
        ids: list,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.getDeviceList();
      });
    },

    // 批量升级
    updateRadars() {
      if (this.checkedList.length > 0) {
        this.isBatch = false;
        this.updateRadarList = this.checkedList;
        this.updateType = "2";
      } else {
        this.$message("请选择雷达");
      }
    },

    // 升级雷达
    updateRadar(data) {
      let list = [];
      list.push(data);
      this.updateRadarList = list;
      this.updateType = "2";
    },

    // 升级wifi
    updateWifi(data) {
      let list = [];
      list.push(data);
      this.updateRadarList = list;
      this.updateType = "1";
    },

    // 上传文件成功
    uploadFileSuccess(e) {
      let list = [];
      this.updateRadarList.forEach((item) => {
        // list.push(item.ip + ":" + item.port);
        list.push(item.sn)
      });

      // 升级雷达
      updateOAT({
        // ipPort: list.join(","),
        // radarSn: this.updateRadarList[0].sn,
        radarSn: list.join(","),
        radarType: this.updateRadarList[0].radarType,
        t: {
          // otaType: this.updateType,
          otaType: 3,
          otaUrl: e.data,
        },
      }).then((res) => {
        console.log("升级雷达", res);

        // if (this.webSocket) {
        //   let snList = [];
        //   this.updateRadarList.forEach((item) => {
        //     snList.push(item.sn);
        //   });
        //   this.webSocket.send(snList.join(","));
        // } else {
        //   this.webSocketInit();
        // }

        // this.updateRadarList.forEach((item) => {
        //   this.getRadarUpdate(item);
        // });
      });
    },

    webSocketInit() {
      let that = this;
      // let wsUrl = "ws://172.16.12.66:8082/sstk-plat/ws/oat";
      let wsUrl = "wss://applet.whst.com/wss/sstk-plat/ws/oat";
      // let wsUrl = "ws://120.211.103.37:8082/sstk-plat/ws/oat";


      // 判断websocket环境
      if ("WebSocket" in window) {
        that.webSocket = new WebSocket(wsUrl);
      } else if ("MozWebSocket" in window) {
        that.webSocket = new MozWebSocket(wsUrl);
      } else {
        that.webSocket = new SockJS(wsUrl);
      }

      // websocket连接
      that.webSocket.onopen = () => {
        // console.log("websocket连接成功");
        // let snList = [];
        // that.updateRadarList.forEach((item) => {
        //   snList.push(item.sn);
        // });
        // that.webSocket.send(snList.join(","));
        // console.log("发送消息", snList.join(","));
      };

      // websocket接收消息
      that.webSocket.onmessage = (msg) => {
        let data = JSON.parse(msg.data);
        console.log("接收消息", data, that.showDeviceList);
        if (data.otaStatus >= 0 && data.otaStatus <= 100) {
          that.showDeviceList.forEach((item) => {
            if (item.sn == data.radarSn) {
              item.updateRadarState =
                data.otaStatus == 100 ? "升级成功" : data.otaStatus + "%";
            }
          });
        } else {
          that.showDeviceList.forEach((item) => {
            if (item.sn == data.radarSn) {
              item.updateRadarState = "升级失败";
            }
          });
        }
        that.showDeviceList = JSON.parse(JSON.stringify(that.showDeviceList));
        // switch (data.otaStatus) {
        //   case 1005:
        //     this.$message("HTTP连接错误");
        //     updateFail();
        //     break;
        //   case 1009:
        //     this.$message("文件不合法");
        //     updateFail();
        //     break;
        //   case 10010:
        //     this.$message("缓冲数据异常");
        //     updateFail();
        //     break;
        //   case -1:
        //     updateFail();
        //     break;
        //   default:
        //     that.showDeviceList.forEach((item) => {
        //       if (item.sn == data.radarSn) {
        //         if (that.updateType == "1") {
        //           item.updateWifiState =
        //             data.otaStatus == 100 ? "升级成功" : data.otaStatus + "%";
        //           if (data.otaStatus == 100) {
        //             // setTimeout(() => {
        //             //   // location.reload();
        //             //   this.getDeviceList()
        //             // }, 1000);
        //           }
        //         } else if (that.updateType == "2") {
        //           item.updateRadarState =
        //             data.otaStatus == 100 ? "升级成功" : data.otaStatus + "%";

        //           if (data.otaStatus == 100) {
        //             // setTimeout(() => {
        //             //   // location.reload();
        //             //   this.getDeviceList()
        //             // }, 1000);
        //           }
        //         }
        //       }
        //     });
        //     break;
        // }

        // function updateFail() {
        //   that.showDeviceList.forEach((item) => {
        //     if (item.sn == data.radarSn) {
        //       if (that.updateType == "1") {
        //         item.updateWifiState = "升级失败";
        //       } else if (that.updateType == "2") {
        //         item.updateRadarState = "升级失败";
        //       }
        //     }
        //   });

        //   // setTimeout(() => {
        //   //   // location.reload();
        //   //   this.getDeviceList()
        //   // }, 1000);
        // }

        // if (data.otaStatus == -1) {
        //   that.showDeviceList.forEach((item) => {
        //     if (item.sn == data.radarSn) {
        //       if (that.updateType == "1") {
        //         item.updateWifiState = "升级失败";
        //       } else if (that.updateType == "2") {
        //         item.updateRadarState = "升级失败";
        //       }
        //     }
        //   });
        // } else {
        //   that.showDeviceList.forEach((item) => {
        //     if (item.sn == data.radarSn) {
        //       if (that.updateType == "1") {
        //         item.updateWifiState =
        //           data.otaStatus == 100 ? "升级成功" : data.otaStatus + "%";
        //       } else if (that.updateType == "2") {
        //         item.updateRadarState =
        //           data.otaStatus == 100 ? "升级成功" : data.otaStatus + "%";
        //       }
        //     }
        //   });
        // }
      };

      // websocket错误
      that.webSocket.onerror = (ev) => {
        console.log("websocket错误");
      };

      // websocket关闭
      that.webSocket.onclose = (e) => {
        console.log("websocket关闭", e);
      };
    },

    // 查询雷达升级进度
    getRadarUpdate(data) {
      let timer = setInterval(() => {
        queryOATProgress({
          radarSn: data.sn,
          radarType: data.radarType,
        })
          .then((res) => {
            console.log("查询雷达升级进度", res);
            if (res.data.otaStatus == -1) {
              clearInterval(timer);
              console.log("升级失败");
              this.showDeviceList.forEach((item) => {
                if (item.ip == data.ip) {
                  if (this.updateType == "1") {
                    item.updateWifiState = "升级失败";
                  } else if (this.updateType == "2") {
                    item.updateRadarState = "升级失败";
                  }
                }
              });
            } else {
              console.log(res.data.otaStatus);
              this.showDeviceList.forEach((item) => {
                if (item.ip == data.ip) {
                  if (this.updateType == "1") {
                    item.updateWifiState = res.data.otaStatus + "%";
                  } else if (this.updateType == "2") {
                    item.updateRadarState = res.data.otaStatus + "%";
                  }
                }
              });

              if (res.data.otaStatus == 100) {
                if (this.updateType == "1") {
                  item.updateWifiState = "升级成功";
                } else if (this.updateType == "2") {
                  item.updateRadarState = "升级成功";
                }
                clearInterval(timer);
              }
            }

            this.showDeviceList = JSON.parse(
              JSON.stringify(this.showDeviceList)
            );
          })
          .catch(() => {
            clearInterval(timer);
          });
      }, 5000);
    },

    // 上传文件失败
    uploadFileFail(e) {
      console.log("上传文件失败", e, this.fileData);
    },

    // 添加删除雷达
    addDelDevice() {
      if (this.room == "") {
        this.$message("请先选择房间");
      } else {
        this.rooms.forEach((item) => {
          if (item.id == this.room) {
            this.deviceTitle = `${item.buildingName}-${item.floorName}-${item.name}`;
          }
        });

        this.isAddDelRadar = true;
        this.isLifeRadar = false;
        this.isDownRadar = false;

        this.showMask();
      }
    },

    // 批量设置
    batchSet() {
      if (this.checkedList.length > 0) {
        let list = [];
        this.checkedList.forEach((item) => {
          list.push(item.ip + ":" + item.port);
        });
        let ipPorts = list.join(",");
        if (this.checkedList[0].radarType == "1001") {
          this.isAddDelRadar = false;
          this.isLifeRadar = true;
          this.isDownRadar = false;

          this.lifeSets = {
            ipPort: ipPorts,
            t: {
              bedRange: "",
              zeroPowerThre: "",
              zeroConfidenceThre: "",
              binsValid: "",
              breathFilterBufferSize: "",
              heartFilterBufferSize: "",
              rangeStartIndIfEmpty: "",
              rangeEndIndIfEmpty: "",
              threIfEmpty: "",
              windowLenIfEmpty: "",
              turnBufferSize: "",
              turnBufferSumThre: "",
              frameSkipNum: "",
              leftRange: "",
              rightRange: "",
              leftAngleInd: "",
              rightAngleInd: "",
              getUpBufferSize: "",
              getUpThre: "",
              searchType: "",
              keepCountThre: "",
              emptyToHasThre: "",
              hasToEmptyCntThre: "",
              continueEmptyThre: "",
              alarmEn: "",
              saveMinNum: "",
              alarmMinThre: "",
              breathHighAlarmThre: "",
              breathLowAlarmThre: "",
              heartHighAlarmThre: "",
              heartLowAlarmThre: "",
              leaveBedLongTimeThre: "",
              noTurnLongTimeThre: "",
            },
          };
        } else if (this.checkedList[0].radarType == "1002") {
          this.isAddDelRadar = false;
          this.isLifeRadar = false;
          this.isDownRadar = true;

          this.downSets = {
            ipPort: ipPorts,
            second: "",
            boundaryLeft: "",
            boundaryRight: "",
            boundaryForward: "",
            boundaryBackward: "",
          };
        }

        this.showMask();
      } else {
        this.$message("请选择雷达");
      }
    },

    // 雷达设置
    setRadar(data) {
      if (data.radarType == "1001") {
        this.isAddDelRadar = false;
        this.isLifeRadar = true;
        this.isDownRadar = false;

        this.lifeSets = {
          ipPort: "",
          t: {
            bedRange: "",
            zeroPowerThre: "",
            zeroConfidenceThre: "",
            binsValid: "",
            breathFilterBufferSize: "",
            heartFilterBufferSize: "",
            rangeStartIndIfEmpty: "",
            rangeEndIndIfEmpty: "",
            threIfEmpty: "",
            windowLenIfEmpty: "",
            turnBufferSize: "",
            turnBufferSumThre: "",
            frameSkipNum: "",
            leftRange: "",
            rightRange: "",
            leftAngleInd: "",
            rightAngleInd: "",
            getUpBufferSize: "",
            getUpThre: "",
            searchType: "",
            keepCountThre: "",
            emptyToHasThre: "",
            hasToEmptyCntThre: "",
            continueEmptyThre: "",
            alarmEn: "",
            saveMinNum: "",
            alarmMinThre: "",
            breathHighAlarmThre: "",
            breathLowAlarmThre: "",
            heartHighAlarmThre: "",
            heartLowAlarmThre: "",
            leaveBedLongTimeThre: "",
            noTurnLongTimeThre: "",
          },
        };

        this.getLifeInfo(data);
      } else if (data.radarType == "1002") {
        this.isAddDelRadar = false;
        this.isLifeRadar = false;
        this.isOtherSet = false;
        this.isDownRadar = true;

        this.downSets = {
          ipPort: "",
          second: "",
          boundaryLeft: "",
          boundaryRight: "",
          boundaryForward: "",
          boundaryBackward: "",
        };

        this.getDownInfo(data);
      }

      this.showMask();
    },

    // 告警设置
    handleAlarm(data) {
      this.alarmForm = {};
      this.currDevice = data;

      let tip = this.$message({
        message: "查询当前设置中，请稍候",
        iconClass: "el-icon-loading el-message__icon",
        duration: 0,
      });
      queryAlarm({
        ip: data.ip,
        port: data.port,
        sn: data.sn,
      })
        .then((res) => {
          tip.close();
          this.alarmForm = res.data;
          this.isAlarmMask = true;
        })
        .catch((err) => {
          tip.close();
        });
    },

    handleSetAlarm() {
      setAlarm({
        ipPort: this.currDevice.ip + ":" + this.currDevice.port,
        sn: this.currDevice.sn,
        t: this.alarmForm,
      }).then((res) => {
        console.log("设置成功", res);
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.isAlarmMask = false;
      });
    },

    // 生命监测雷达配置
    // 查询生命雷达算法参数
    getLifeInfo(data) {
      queryArithmetic({
        ip: data.ip,
        port: data.port,
      }).then((res) => {
        this.lifeSets.ipPort = data.ip + ":" + data.port;
        this.lifeSets.t = res.data;
      });
    },

    // 设置生命雷达算法参数
    lifeRadarSet() {
      updateArithmetic(this.lifeSets).then((res) => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.lifeSets = {
          ipPort: "",
          t: {
            bedRange: "",
            zeroPowerThre: "",
            zeroConfidenceThre: "",
            binsValid: "",
            breathFilterBufferSize: "",
            heartFilterBufferSize: "",
            rangeStartIndIfEmpty: "",
            rangeEndIndIfEmpty: "",
            threIfEmpty: "",
            windowLenIfEmpty: "",
            turnBufferSize: "",
            turnBufferSumThre: "",
            frameSkipNum: "",
            leftRange: "",
            rightRange: "",
            leftAngleInd: "",
            rightAngleInd: "",
            getUpBufferSize: "",
            getUpThre: "",
            searchType: "",
            keepCountThre: "",
            emptyToHasThre: "",
            hasToEmptyCntThre: "",
            continueEmptyThre: "",
            alarmEn: "",
            saveMinNum: "",
            alarmMinThre: "",
            breathHighAlarmThre: "",
            breathLowAlarmThre: "",
            heartHighAlarmThre: "",
            heartLowAlarmThre: "",
            leaveBedLongTimeThre: "",
            noTurnLongTimeThre: "",
          },
        };
        this.isSetAlarm = false;
        this.back();
      });
    },

    // 跌倒雷达配置
    getDownInfo(data) {
      this.downSets.ipPort = data.ip + ":" + data.port;
      this.downSets.sn = data.sn
      queryDelayInfo({
        radarSn: data.sn
      }).then((resp) => {
        console.log("延迟", resp);
        this.downSets.second = resp.data.second;
      });

      queryBoundaryInfo({
        radarSn: data.sn
      }).then((res) => {
        console.log("边界", res);
        this.downSets.boundaryLeft = res.data.boundaryLeft;
        this.downSets.boundaryRight = res.data.boundaryRight;
        this.downSets.boundaryForward = res.data.boundaryForward;
        this.downSets.boundaryBackward = res.data.boundaryBackward;
      });
    },

    downRadarSetDelay() {
      setDelayInfo({
        // ipPort: this.downSets.ipPort,
        radarSn: this.downSets.sn,
        t: {
          radarSn: this.downSets.sn,
          second: this.downSets.second,
        },
      }).then((res) => {
        if (res.data[0]) {
          this.$message({
            type: "success",
            message: "设置延迟信息成功",
          });
        } else {
          this.$message({
            type: "error",
            message: "设置延迟信息失败",
          });
        }
      });
    },

    downRadarSet() {
      setBoundaryInfo({
        // ipPort: this.downSets.ipPort,
        radarSn: this.downSets.sn,
        t: {
          radarSn: this.downSets.sn,
          boundaryLeft: this.downSets.boundaryLeft,
          boundaryRight: this.downSets.boundaryRight,
          boundaryForward: this.downSets.boundaryForward,
          boundaryBackward: this.downSets.boundaryBackward,
        },
      }).then((res) => {
        if (res.data[0]) {
          this.$message({
            type: "success",
            message: "设置边界信息成功",
          });
        } else {
          this.$message({
            type: "error",
            message: "设置边界信息失败",
          });
        }
      });
    },

    // downRadarSet() {
    //   if (
    //     String(this.downSets.second) != "" &&
    //     String(this.downSets.boundaryLeft) != "" &&
    //     String(this.downSets.boundaryRight) != "" &&
    //     String(this.downSets.boundaryForward) != "" &&
    //     String(this.downSets.boundaryBackward) != ""
    //   ) {
    //     let promise1 = new Promise((resolve, reject) => {
    //       setDelayInfo({
    //         ipPort: this.downSets.ipPort,
    //         t: {
    //           second: this.downSets.second,
    //         },
    //       }).then((res) => {
    //         console.log("设置跌倒雷达延迟信息", res);
    //         if (res.data[0]) {
    //           resolve(res);
    //         } else {
    //           this.$message({
    //             type: "error",
    //             message: "设置延迟信息失败",
    //           });
    //         }
    //       });
    //     });
    //     let promise2 = new Promise((resolve, reject) => {
    //       setBoundaryInfo({
    //         ipPort: this.downSets.ipPort,
    //         t: {
    //           boundaryLeft: this.downSets.boundaryLeft,
    //           boundaryRight: this.downSets.boundaryRight,
    //           boundaryForward: this.downSets.boundaryForward,
    //           boundaryBackward: this.downSets.boundaryBackward,
    //         },
    //       }).then((res) => {
    //         console.log("设置跌倒雷达边界信息", res);
    //         if (res.data[0]) {
    //           resolve(res);
    //         } else {
    //           this.$message({
    //             type: "error",
    //             message: "设置边界信息失败",
    //           });
    //         }
    //       });
    //     });

    //     Promise.all([promise1, promise2]).then((res) => {
    //       console.log(res);
    //       this.$message({
    //         type: "success",
    //         message: "设置成功",
    //       });
    //       this.downSets = {
    //         second: "",
    //         boundaryLeft: "",
    //         boundaryRight: "",
    //         boundaryForward: "",
    //         boundaryBackward: "",
    //       };
    //       this.back();
    //     });
    //   } else {
    //     this.$message("设置信息不能为空");
    //   }
    // },

    // 雷达详情
    radarInfo(data) {
      console.log("雷达详情", data);
      this.drawer = true;
      this.radarForm = JSON.parse(JSON.stringify(data));

      queryWifiVersion({
        radarSn: data.sn,
        radarType: data.radarType,
      }).then((res) => {
        console.log("查询雷达wifi", res);
        this.radarForm.wifiVersion = res.data.wifiVersion;

        this.radarForm = JSON.parse(JSON.stringify(this.radarForm));
      });

      querySoftVersion({
        radarSn: data.sn,
        // radarType: data.radarType,
      }).then((res) => {
        console.log("查询雷达版本", res);

        this.radarForm.softVersion = res.data.softVersion;
        this.radarForm = JSON.parse(JSON.stringify(this.radarForm));
      });

      getCCID({
        radarSn: data.sn
      }).then(res => {
        this.radarForm.ccid = res.data.ccid;
        this.radarForm = JSON.parse(JSON.stringify(this.radarForm));
      })
    },

    // 雷达更新
    updateRadarInfo() {
      updateDevice(this.radarForm).then((res) => {
        this.$message({
          type: "success",
          message: "雷达信息更新成功",
        });
        this.getDeviceList();
      });
    },

    // 雷达信息设置
    handleRadar(data) {
      this.isInfo = true;
      this.infoForm = {
        radarSn: data.sn,
        t: {},
      };
      queryRadarInfo({
        radarSn: data.sn
      }).then((res) => {
        this.infoForm.t = res.data;
      });
    },

    handleSetRadar() {
      setRadarInfo(this.infoForm).then((res) => {
        this.$message({
          type: "success",
          message: "设置雷达信息成功",
        });
        this.isInfo = false;
      });
    },

    setOther(data) {
      console.log('其它设置', data)

      this.otherInfo = {
        ip: data.ip,
        port: data.port,
        sn: data.sn
      }

      this.mircoMoveThre = ''
      this.retentionEnable = 2
      this.retentionMinute = ''
      this.isAddDelRadar = false;
      this.isLifeRadar = false;
      this.isDownRadar = false;
      this.isOtherSet = true;
      this.showMask()

      getMirco({
        radarSn: data.sn
      }).then(res => {
        console.log('微动检测', res)
        this.mircoMoveThre = res.data.mircoMoveThre;
      })

      getRetention({
        radarSn: data.sn
      }).then(res => {
        console.log('滞留', res)
        this.retentionEnable = res.data.enable;
        this.retentionMinute = res.data.minute;
      })
    },

    handleSetMirco() {
      setMirco({
        "radarSn": this.otherInfo.sn,
        "t": {
          "radarSn": this.otherInfo.sn,
          "mircoMoveThre": this.mircoMoveThre
        }
      }).then(res => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
      })
    },

    handleSetRention() {
      setRetention({
        "radarSn": this.otherInfo.sn,
        "t": {
          "radarSn": this.otherInfo.sn,
          "enable": this.retentionEnable,      //是否开启
          "minute": this.retentionMinute     //滞留时间 单位 分钟
        }
      }).then(res => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
      })
    },

    showMask() {
      this.isMask = true;
      document.getElementsByTagName("body")[0].appendChild(this.$refs.mask);
      document.getElementById("app").style.filter = "blur(2px)";
    },

    back() {
      this.isMask = false;
      document.getElementsByTagName("body")[0].removeChild(this.$refs.mask);
      document.getElementById("app").style.filter = "blur(0px)";
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight, false);
    if (this.isMask) {
      this.back();
    }
    if (this.webSocket) {
      this.webSocket.close();
    }
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-device {
  width: 100%;
  // padding: 70px 60px 60px 60px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .real-time {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 40px 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .option-box {
      display: flex;
      justify-content: center;

      .option-btn {
        width: 100px;
        height: 40px;
        font-size: 14px;
        color: #fff;
        background: #1d63fd;
        border-radius: 8px;
        border: none;
        margin: 0 10px 0 0;
      }

      // .option-btn:nth-child(4) {
      //   width: 150px;
      //   margin-right: 0;
      // }
      // .option-btn:last-child {
      //   width: 150px;
      //   margin-right: 0;
      // }
    }

    .monitor-info-title {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 40px;
      padding-right: 50px;

      div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .check-box {
        width: 25px;
        height: 25px;
        box-sizing: border-box;
        border: 1px solid #c9d5ef;
        background: #fff;
        display: block;
      }

      .check-all-box {
        background: #1d63fd;
      }

      .check-half-box {
        border: 5px solid #c9d5ef;
        background: #1d63fd;
      }
    }

    .list-box {
      flex: 1;

      .monitor-info {
        height: 60px;
        display: flex;
        align-items: center;
        font-size: 15px;
        padding-right: 50px;

        div {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .check-box {
          width: 25px;
          height: 25px;
          box-sizing: border-box;
          border: 1px solid #c9d5ef;
          background: #fff;
          display: block;
        }

        .check-box-select {
          background: #1d63fd;
        }

        .radar-set-text {
          color: #1d63fd;
          cursor: pointer;
        }
      }
    }
  }

  .page-num-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;

    .page-num-list {
      height: 60px;
      display: flex;
      align-items: center;

      .page-num {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #26415f;
      }

      .page-num-active {
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #c9d5ef;
        border-radius: 8px;
      }
    }
  }
}

.drawer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .drawer-content {
    padding-right: 12px;
    flex: 1;
  }

  .drawer-footer {
    padding: 0 12px;
    height: 60px;
    box-sizing: border-box;
    border-top: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.alarm-mask-box {
  width: 100%;
  height: 100%;
  background: rgba(33, 64, 132, 0.2);
  position: fixed;
  left: 0;
  top: 0;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;

  .alarm-mask {
    width: 60%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .alarm-title-box {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #26415f;
      background: #f5f9ff;
      padding: 0 30px;
      box-sizing: border-box;

      .alarm-title-text {
        height: 60px;
        line-height: 60px;
      }
    }

    .alarm-content-box {
      padding: 10px 30px;

      .alarm-content-title {
        font-weight: bold;
      }

      .alarm-content {
        padding: 5px 30px;
        font-size: 15px;

        .alarm-content-info {
          padding: 5px 0;
          display: flex;
          align-items: center;
        }
      }
    }

    .alarm-btn {
      display: flex;
      justify-content: center;
      padding: 5px 0;
      background: #f5f9ff;
    }
  }
}
</style>
<style>
.page-device .real-time .el-select {
  width: 150px;
  margin-right: 38px;
}

.el-input__inner {
  border-color: 1px solid#c9d5e7;
  border-radius: 8px;
}

.time-select .el-select {
  width: 100px;
  margin: 0 auto;
}

.time-select .el-input__inner {
  font-size: 13px;
}

.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}

.mask-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(33, 64, 132, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #617f9e;
}

.device-add-box {
  width: 1748px;
  height: 980px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 36px 30px;
  display: flex;
  flex-direction: column;
}

.device-title-box {
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #26415f;
}

.device-room-name {
  height: 35px;
  line-height: 35px;
}

.device-select-box {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 56px 0 22px;
}

.device-select-box .el-select {
  margin-right: 20px;
}

.device-select-box .el-input {
  width: 200px;
  margin-right: 20px;
}

.device-select-text {
  min-width: 80px;
}

.device-btn {
  width: 100px;
  color: #fff;
  background: #1d63fd;
  border-radius: 8px;
  border: none;
}

.device-list-title-box {
  height: 46px;
  display: flex;
}

.device-list-title {
  height: 46px;
  line-height: 46px;
  flex: 1;
  text-align: center;
}

.device-list-title-one {
  width: 105.5px;
}

.device-content-box {
  flex: 1;
}

.device-list-content-box {
  height: 100px;
  display: flex;
}

.device-list-content-one {
  width: 105.5px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-check-box {
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  border: 1px solid #c9d5ef;
  background: #fff;
}

.device-check-box-del {
  background: #1d63fd;
}

.device-list-content {
  flex: 1;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.set-list-content {
  color: #1d63fd;
  cursor: pointer;
}

.life-radar-box {
  width: 1092px;
  height: 658px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.life-radar-header {
  height: 64px;
  background: #f5f9ff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.life-radar-title {
  height: 64px;
  line-height: 64px;
  margin-left: 72px;
}

.life-radar-close {
  margin-right: 20px;
}

.life-radar-content {
  width: 100%;
  flex: 1;
  padding: 50px 72px 0;
  box-sizing: border-box;
  overflow-y: auto;
}

.life-set-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.life-set-box {
  margin-bottom: 20px;
}

.life-set-box-four {
  flex: 0 0 23%;
}

.life-set-name {
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  margin-bottom: 6px;
}

.life-set-btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.life-set-btn {
  width: 154px;
  background: #1d63fd;
  color: #fff;
  border: none;
  border-radius: 8px;
}

.down-radar-box {
  width: 356px;
  height: 708px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/views/system/deviceDown.vue